import React, { ReactNode } from 'react';
import UIModal, { UIModalProps } from '@/components/shared/UIModal';
import UIButton from '@/components/shared/UIButton';
import './UIConfirmationModal.scss';

export interface UIConfirmationModalProps extends UIModalProps {
  onConfirm: () => void;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  isConfirming?: boolean;
  /**
   * Error message to display in the modal
   */
  error?: string | null;
}

const baseClass = 'UIConfirmationModal';

const UIConfirmationModal: React.FC<UIConfirmationModalProps> = ({
  isOpen,
  onClose = () => {},
  onConfirm,
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isConfirming = false,
  error = null,
  ...modalProps
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <UIModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="small"
      {...modalProps}
    >
      <div className={`${baseClass}__body`}>
        {message}
      </div>

      {error && (
        <div className={`${baseClass}__error`}>
          {error}
        </div>
      )}

      <div className={`${baseClass}__footer`}>
        <UIButton
          variant="secondary"
          onClick={onClose}
          disabled={isConfirming}
        >
          {cancelText}
        </UIButton>
        <UIButton
          variant="danger"
          onClick={onConfirm}
          loading={isConfirming}
        >
          {confirmText}
        </UIButton>
      </div>
    </UIModal>
  );
};

export default UIConfirmationModal;
